import RiepilogoEventi from "./pages/RiepilogoEventi.vue";

export default {
    RiepilogoEventi,
};
